module.exports = __webpack_public_path__ + "static/CMHA_ThankYou-f67ca5716a7a4b391b2479d7345717cc.svg";